import { useState, useEffect } from "react";

export function useCallTimer(startedAt: number | null, endedAt: number | null, running: boolean) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (endedAt && startedAt) {
      setElapsed(Math.floor((endedAt - startedAt) / 1000));
      return;
    }
    if (!running || !startedAt) {
      setElapsed(0);
      return;
    }
    const tick = () => setElapsed(Math.floor((Date.now() - startedAt) / 1000));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [running, startedAt, endedAt]);

  const mm = String(Math.floor(elapsed / 60)).padStart(2, "0");
  const ss = String(elapsed % 60).padStart(2, "0");
  return `${mm}:${ss}`;
}
